import { ReactNode } from "react";
import "./SignupUI.scss";

interface SignupFieldProps {
  label?: string;
  htmlFor?: string;
  /** The input itself — kept as a slot so each step keeps its own control. */
  children: ReactNode;
  hint?: ReactNode;
  error?: ReactNode;
  /** Leading glyph inside the field, e.g. the phone-number note icon. */
  icon?: string;
}

/** Label, control, then hint or error. Error replaces hint when both exist. */
export const SignupField = ({ label, htmlFor, children, hint, error, icon }: SignupFieldProps) => (
  <div className={"suField" + (error ? " suField--error" : "")}>
    {label && (
      <label className="suField__label" htmlFor={htmlFor}>
        {label}
      </label>
    )}

    <div className="suField__control">{children}</div>

    {/* The error is a div, not a p: callers pass block-level content (an
        `ErrorMessage`, which renders its own wrapper), and a paragraph may
        only contain phrasing content. */}
    {error ? (
      <div className="suField__error" role="alert">
        {error}
      </div>
    ) : (
      hint && (
        <p className="suField__hint">
          {icon && <img src={icon} alt="" aria-hidden="true" />}
          <span>{hint}</span>
        </p>
      )
    )}
  </div>
);
